class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    if (!this.dataset.url || this.hasAttribute('data-eager') || !('IntersectionObserver' in window)) {
      this.load();
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        this.load();
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    observer.observe(this);
  }
  async load(url = this.dataset.url) {
    try {
      const response = await fetch(url);
      const text = await response.text();
      const fresh = new DOMParser().parseFromString(text, 'text/html').querySelector('product-recommendations');
      if (fresh?.innerHTML.trim()) {
        this.innerHTML = fresh.innerHTML;
        this.dispatchEvent(new CustomEvent('fivl:content', { bubbles: true }));
        const heading = this.querySelector('[data-complementary-heading]');
        if (heading && this.dataset.heading) heading.textContent = this.dataset.heading;
      } else if (this.dataset.fallback && url !== this.dataset.fallback) {
        return this.load(this.dataset.fallback);
      } else {
        this.remove();
      }
    } catch (error) {
      this.remove();
    }
  }
}
if (!customElements.get('product-recommendations')) customElements.define('product-recommendations', ProductRecommendations);
